import pt_BR from './pt_BR.json'
import en_US from './en_US.json'
import fr_FR from './fr_FR.json'
import de_DE from './de_DE.json'
import es_ES from './es_ES.json'
import it_IT from './it_IT.json'

export const languages = {
pt_BR: pt_BR,
en_US: en_US,
fr_FR: fr_FR,
de_DE: de_DE,
es_ES: es_ES,
it_IT: it_IT,
}


//////////////////
// WEBPACK FOOTER
// ./static/translation/index.js
// module id = null
// module chunks = 